import { assertNotNullish } from '@synapex/tools/typescript';
import { TME_BASE_URL, TGSTAT_BASE_URL } from './telegram.js';
export class TelegramPeerReferenceError extends Error {
    key;
    constructor(key) {
        super(key);
        this.key = key;
        this.name = this.constructor.name;
    }
}
//based on Telethon
//optional https, optional www, required hostname, required /, optional @|+|joinchat
const URL_PREFIX = /(?:https?:\/\/)?(?:www\.)?(?:telegram\.(?:me|dog)|t\.me)\/(@|\+|joinchat\/)?/i;
const TG_JOIN_PREFIX = /tg:\/\/(join)\?invite=/i;
const VALID_USERNAME_RE = /^[a-z](?:(?!__)\w){1,30}[a-z\d]$/i;
//based on gramjs
export function parseTelegramPeerReferenceOrThrow(input) {
    function rtrim(s, mask) {
        while (true) {
            const lastChar = s.at(-1);
            if (lastChar && mask.includes(lastChar)) {
                s = s.slice(0, -1);
            }
            else {
                break;
            }
        }
        return s;
    }
    input = input.trim();
    const m = input.match(URL_PREFIX) || input.match(TG_JOIN_PREFIX);
    if (m) {
        //strip prefix
        input = input.replace(m[0], '');
        if (m[1]) {
            /*
            Prefix can't have trailing slash
            https://core.telegram.org/api/links#chat-invite-links
      
            username can have trailing slash
            https://core.telegram.org/api/links
      
      
            m[1] - is @ or + or joinchat/
            this means it is hash
      
            m[1] is included into m[0], so already stripped
            */
            return {
                type: 'invite',
                invite_hash: input,
            };
        }
        else {
            //strip trailing slashes
            input = rtrim(input, '/');
        }
    }
    else {
        if (input.startsWith('@')) {
            input = input.slice(1);
        }
        else {
            //if input is neither special URL, nor @, we don't accept it
            throw new TelegramPeerReferenceError('NEITHER_URL_NOR_USERNAME');
        }
    }
    if (input.match(VALID_USERNAME_RE)) {
        //username is lovercased, hash is not
        return {
            type: 'username',
            username: input.toLowerCase(),
        };
    }
    throw new TelegramPeerReferenceError('USERNAME_INVALID');
}
export function parseTelegramPeerReference(input) {
    try {
        return parseTelegramPeerReferenceOrThrow(input);
    }
    catch {
        return null;
    }
}
export function telegramGetPeerTmeUrl(channel) {
    let pathname;
    if (channel.username) {
        pathname = channel.username;
    }
    else if (channel.invite_hash) {
        pathname = `+${channel.invite_hash}`;
    }
    else {
        return null;
    }
    return new URL(pathname, TME_BASE_URL);
}
export function telegramGetPeerTgstatUrl(channel) {
    let pathname;
    if (channel.username) {
        pathname = `channel/${channel.username}`;
    }
    else if (channel.invite_hash) {
        pathname = `channel/${channel.invite_hash}`;
    }
    else {
        return null;
    }
    return new URL(pathname, TGSTAT_BASE_URL);
}
export function telegramDescriptorToPeerString(channel) {
    if (channel.username) {
        return `@${channel.username}`;
    }
    if (channel.invite_hash) {
        return new URL(`+${channel.invite_hash}`, TME_BASE_URL).href;
    }
    return null;
}
export const telegramGetMessageTmeUrl = (channel, messageId) => {
    //https://core.telegram.org/api/links#message-links
    if (channel.username) {
        return new URL(`${channel.username}/${messageId}`, TME_BASE_URL);
    }
    if (channel.id) {
        const channelId = channel.id.replace(/^-100/, '');
        //private channel
        return new URL(`c/${channelId}/${messageId}`, TME_BASE_URL);
    }
    return null;
};
export const telegramGetMessageTmeUrlOrThrow = (channel, messageId) => {
    const url = telegramGetMessageTmeUrl(channel, messageId);
    assertNotNullish(url, JSON.stringify({ channel, messageId }));
    return url;
};
export const telegramGetStartchannelLink = (botUsername) => {
    const tmeUrl = telegramGetPeerTmeUrl({ username: botUsername });
    const sp = new URLSearchParams({ admin: 'invite_users' });
    return `${tmeUrl.href}?startchannel&${sp.toString()}`;
};
//# sourceMappingURL=descriptor.js.map